<template>
  <div class="icon-container" v-if="type === 'question-mark'">
    <svg
      class="question-mark"
      :class="{ 'question-mark-hover': hoverEffect }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path
          d="M11,12.3V13c0,0-1.8,0-2,0v-0.6c0-0.6,0.1-1.4,0.8-2.1c0.7-0.7,1.6-1.2,1.6-2.1c0-0.9-0.7-1.4-1.4-1.4 c-1.3,0-1.4,1.4-1.5,1.7H6.6C6.6,7.1,7.2,5,10,5c2.4,0,3.4,1.6,3.4,3C13.4,10.4,11,10.8,11,12.3z"
        ></path>
        <circle cx="10" cy="15" r="1"></circle>
        <path
          class="question-mark"
          d="M10,2c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S5.6,2,10,2 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 L10,0z"
        ></path>
      </g>
    </svg>
  </div>
  <div class="icon-container" v-else-if="type === 'alert-icon'">
    <svg
      class="alert-icon"
      :class="{ 'alert-icon-hover': hoverEffect }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <g transform="translate(-2.000000, -2.000000)" fill="#FFFFFF">
          <path
            class="alert-icon"
            d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,10.5 C11.4477153,10.5 11,10.9477153 11,11.5 L11,11.5 L11,16 C11,16.5522847 11.4477153,17 12,17 C12.5522847,17 13,16.5522847 13,16 L13,16 L13,11.5 C13,10.9477153 12.5522847,10.5 12,10.5 Z M12,7 C11.4477153,7 11,7.44771525 11,8 C11,8.55228475 11.4477153,9 12,9 C12.5522847,9 13,8.55228475 13,8 C13,7.44771525 12.5522847,7 12,7 Z"
            id="🎨-Icon-style"
          ></path>
        </g>
      </g>
    </svg>
  </div>
  <div v-else class="icon" :class="type"></div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: null,
    },
    width: {
      type: Number,
      default: 25,
    },
    height: {
      type: Number,
      default: 25,
    },
    hoverEffect: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.icon {
  width: 22px;
  height: 22px;
  text-align: center;
  background-size: 12px;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 50%;
  margin: auto;
}

.icon-container {
}

.icon.checkmark {
  background-color: $primary;
  background-image: url('../../../icons/custom/checkmark.svg');
  color: #fff;
}

.icon.cross {
  background-color: $gray-500;
  background-image: url('../../../icons/custom/cross.svg');
  color: #fff;
}

.alert-icon {
  fill: $husleie-blue;
}

.alert-icon-hover:hover {
  border-radius: 50%;
  background: $husleie-blue;
  fill: #fff;
}

.question-mark {
  fill: $husleie-blue;
}

.question-mark-hover:hover {
  border-radius: 50%;
  background: $husleie-blue;
  fill: #fff;
}
</style>
